import React, { Component } from "react";
import EntryForm from "./Screens/EntryForm";
import ApproachSelect from "./Screens/ApproachSelect";
import Success from "./Screens/Success";
import PactUser from "../classes/PactUser";
import ContractSelect from "./Screens/ContractSelect";
import PathwaySelect from "./Screens/PathwaySelect";
import { withStyles } from "@material-ui/core";
import { Stepper, Step, StepLabel, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import { Grid, Divider } from "@material-ui/core";
import { createTheme } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import { Tailoring } from "./Screens/Tailoring";
import { Dashboard } from "./Screens/Dashboard";

// https://codesandbox.io/s/m5mq9976k9?file=/demo.js:398-465 Reference for good display of page
// test test this is a comment
const theme = createTheme({
  palette: {
    primary: {
      main: "#002b55",
    },
    secondary: {
      main: "#56b7e9",
    },
  },
  shape: {
    borderRadius: 0,
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    useNextVariants: true,
  },
});

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mitre.org">
        MITRE Corporation
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const styles = (theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "red",
    },
    // width: "100%",
    // backgroundColor: theme.palette.background.paper,
    // width: "100%"
  },

  header: {
    backgroundColor: "#E5EFF4",
    // width: "100%"
    marginBottom: "1rem",
    marginTop: 0,
    //paddingLeft: theme.spacing(1),
    //paddingRight: theme.spacing(1),
  },

  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 10),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  imageResize: {
    backgroundImage: `url(${process.env.PUBLIC_URL + '/img/Handshakelogo.png'})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "100%",
    height: "0",
    paddingTop: "25%", //"66.64%", /* (img-height / img-width * container-width) */
    /* (853 / 1280 * 100) */
    //backgroundColor: theme.palette.background.paper,
    //padding: theme.spacing(6),
  },

  footer: {
    //backgroundColor: theme.palette.background.paper,
    //padding: theme.spacing(6),
  },
});

var currentContext = new PactUser();
/*
const styles = (theme) => ({
  root: {
    backgroundColor: '#e3ebfd;',
    width: '50%',
    margin: '6rem auto',
    border: '1px solid #999',
    '& .MuiStepIcon-root.MuiStepIcon-active': {
      color: 'red',
    },
  },
});
*/
export class PactForm extends Component {
  state = {
    step: 0,
    projectName: "",
    projectNature: "",
    urgency: false,
    DBS: false,
    EstCosts: "",
    pathwayChoice: "",
  };

  getStepsContent(step) {
    switch (step) {
      case 1:
        return "Step One (Project Information)";
      case 2:
        return "Step Two (Details)";
      case 3:
        return "Step Three (Acquisition Pathways)";
      case 4:
        return "Step Four (Acquisition Approach)";
      case 5:
        return "Step Five (Select Contract Type)";
      case 6:
        return "Step Six (Confirm Information)";
      default:
        return "Unknown Step";
    }
  }

  getSteps() {
    return [
      "Project Information",
      "Details",
      "Acquisition Pathway",
      "Acquisition Approach",
      "Select Contract Type",
      "Tailor Your Approach",
      "Confirm Information",
    ];
  }

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;

    if (step === 1) {
      //this.props.currentContext.createTailoringChoices(
      //this.state.EstCosts,
      //this.state.pathwayChoice
      //);
    }
    this.setState({
      step: step + 1,
    });
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  // Handle fields change
  handleChange = (input) => (e) => {
    currentContext.updateContext([input], [e.target.value]);
    this.props.currentContext.applyChoices();
    this.setState({ [input]: e.target.value });
  };

  renderSwitch(step, values) {
    switch (step) {
      /*case 0:
        return <IntroView />;*/
      case 0:
        return (
          <EntryForm
            nextStep={this.nextStep}
            handleChange={this.handleChange}
            values={values}
            currentContext={currentContext}
          />
        );
      case 1:
        return (
          <PathwaySelect
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handleChange={this.handleChange}
            currentContext={currentContext}
            values={values}
          />
        );
      case 2:
        return (
          <ApproachSelect
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handleChange={this.handleChange}
            currentContext={currentContext}
            values={values}
          />
        );
      case 3:
        return (
          <ContractSelect
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handleChange={this.handleChange}
            currentContext={currentContext}
            values={values}
          />
        );
      case 4:
        return (
          <Tailoring
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            handleChange={this.handleChange}
            values={values}
            currentContext={currentContext}
          />
        );
      case 5:
        return (
          <Dashboard
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            values={values}
            currentContext={currentContext}
          />
        );
      case 6:
        return <Success />;
      default:
    }
  }

  render() {
    const { step } = this.state;
    const steps = [
      "Enter Project Information",
      "Select Acquisition Pathway",
      "Select Acquisition Approaches",
      "Select Contract Type",
      "Tailor Approach",
      "Confirm Information",
    ];
    const {
      projectName,
      projectNature,
      urgency,
      DBS,
      EstCosts,
      occupation,
      city,
      bio,
    } = this.state;
    const values = {
      projectName,
      projectNature,
      urgency,
      DBS,
      EstCosts,
      occupation,
      city,
      bio,
    };

    const { classes } = this.props;
    return (
      <React.Fragment>
        <main>
          <div
            //style={{ backgroundImage: "url(/img/Handshakelogo.png)", backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "75% 100%" }}
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL + '/img/handshakelogo_tight.png'})`,
              backgroundSize: "cover",
              backgroundPosition: "center",

              height: "25vh",
            }}
          />
          <Stepper activeStep={step} alternativeLabel className={classes.root}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </main>

        <Divider className={classes.mt2} />
        <Grid
          container
          item
          className={classes.container}
          style={{ justifyContent: "center", alignItems: "center" }}
          spacing={3}
        >
          <Grid item xs={10}>
            <>{this.renderSwitch(step, values)}</>
          </Grid>
        </Grid>
        <Divider className={classes.my2} />
        <Grid container className={classes.container}></Grid>
        <footer className={classes.footer}>
          <Typography variant="h6" align="center" gutterBottom></Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="textSecondary"
            component="p"
          >
            Draft Version
          </Typography>
          <Copyright />
        </footer>
      </React.Fragment>
    );
  }
}
PactForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PactForm);
